import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['100 ore l’anno perse a pianificare da zero', '10 minuti a settimana. Tutto pronto.'], ['Lezioni improvvisate senza progressione', '300+ sessioni + 6 volumi per ogni livello'], ['Studenti che migliorano lentamente', 'Una progressione logica e misurabile'], ['Genitori che chiedono risultati', 'Schede di valutazione e report pronti'], ['Entrare in palestra impreparati', 'Ogni sessione pianificata e pronta all’uso']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#09281d] px-5 py-20" data-id="element-36" data-mp="qvx0ustyq2ib">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37" data-mp="14vfz8twz1zhf">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38" data-mp="14w7wsaa4q7ac">
          Smetti di improvvisare.{' '}
          <span className="text-emerald-300" data-id="element-39" data-mp="2c4o9ar3rqx3k">
            Inizia a insegnare con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-40" data-mp="2h37vmsm9yawg">
          Unisciti a oltre 1500 docenti di Scienze Motorie che pianificano
          l’intero anno scolastico in meno di 5 minuti.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-41" data-mp="2r2p056psiiqu">
          Sessioni · Esercizi · Progressioni · Valutazione · Tutto organizzato
        </p>
        <div className="mt-10 overflow-hidden border border-emerald-300/30 text-left" data-id="element-42" data-mp="301u26n0k8u7r">
          <div className="grid grid-cols-2 bg-[#10372a] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-43" data-mp="34ssk1r1760d4">
            <p className="p-4 text-slate-300" data-id="element-44" data-mp="39rdlfts6qq35">Senza EDUFIS PRONTO</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-45" data-mp="3errp6zmr7dvd">
              Con EDUFIS PRONTO
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-46" data-mp="1jo3ijkadab53">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-47" data-mp="1eqtm3kok8z7r">
                <span className="text-red-400" data-id="element-48" data-mp="1shoxb3mj7sei">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-49" data-mp="1novsyguz6m2y">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-50" data-mp="22d9t2k10bwft" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-51" data-mp="2bfsur0t2430h">
          <CountdownTimer dark data-id="element-52" data-mp="2bezl9s2pqzen" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#10372a] p-7 text-left" data-id="element-53" data-mp="27e79ar2gigeo">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-54" data-mp="27c39olblc3k7">
            Pacchetto completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-55" data-mp="d0enpz6xz0qb">
            EDUFIS PRONTO™ — 6 Volumi + 5 Bonus
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-56" data-mp="2x9f5fm499id">
            <div data-id="element-57" data-mp="6xbevj8ajsv0">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-58" data-mp="6xtdunmc8l6m">
                €235
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-59" data-mp="3pari36q5y06l">
                €19
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#09281d]" data-id="element-60" data-mp="3u8aue13aw2vw">
              Risparmi €216
            </p>
          </div>
        </div>
        <a href="https://edufis-pronto.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-61" data-mp="3ke0zocqvysi0">
          SÌ, VOGLIO EDUFIS PRONTO
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-62" data-mp="3bdmbn5mjezat">
          <span className="flex gap-1" data-id="element-63" data-mp="19k4vteo96s4z">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-64" data-mp="19j3nvj2jalrh" /> Pagamento
            unico, nessun abbonamento
          </span>
          <span className="flex gap-1" data-id="element-65" data-mp="35l6zkgxonrdg">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="30o6sc2p3kikr" /> Accesso immediato
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="2vou4pfqej7h4">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="2vnslup359gou" /> Garanzia 7
            giorni
          </span>
        </div>
      </div>
    </section>;
}